"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _consts = require("../consts");

var _index = require("../../utils/rtl/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getIconSpacing = function getIconSpacing() {
  return function (_ref) {
    var _TOKENS$marginRightIc;

    var theme = _ref.theme,
        right = _ref.right,
        size = _ref.size,
        onlyIcon = _ref.onlyIcon;

    if (onlyIcon) {
      return null;
    }

    var tokens = _defineProperty({}, _consts.TOKENS.marginRightIcon, (_TOKENS$marginRightIc = {}, _defineProperty(_TOKENS$marginRightIc, _consts.SIZE_OPTIONS.LARGE, theme.orbit.marginButtonIconLarge), _defineProperty(_TOKENS$marginRightIc, _consts.SIZE_OPTIONS.NORMAL, theme.orbit.marginButtonIconNormal), _defineProperty(_TOKENS$marginRightIc, _consts.SIZE_OPTIONS.SMALL, theme.orbit.marginButtonIconSmall), _TOKENS$marginRightIc));

    return (0, _index.rtlSpacing)(right ? "0 0 0 ".concat(tokens[_consts.TOKENS.marginRightIcon][size]) : "0 ".concat(tokens[_consts.TOKENS.marginRightIcon][size], " 0 0"))({
      theme: theme
    });
  };
};

var _default = getIconSpacing;
exports.default = _default;